import AreasVertical from "../../components/areasVertical";
import BannerSubhome from "../../components/bannerSubhome";
import Clientes from "../../components/clientes";
import Contato from "../../components/contato";
import Depoimentos from "../../components/depoimentos";
import LinksVertical from "../../components/linksVertical";
import MarcaVertical from "../../components/marcaVertical";
import Marcas from "../../components/marcas";
import Rodape from "../../components/rodape";
import Video from "../../components/video";

function Solutions() {
    return (
        <>
            <Contato />
            <BannerSubhome
                image="banner_solutions.png"
                imageMobile="banner_solutions_mobile.png"
                title="SOLUTIONS"
                subtitle={
                    <>
                        PARCERIA <strong>ESTRATÉGICA, SOLUÇÕES</strong> DE IMPACTO.
                    </>
                }
                marca={{
                    color: "#4B3BDB",
                    logoSrc: "../assets/omnicore_logo.svg",
                }}
                hoveredBrand="omnicore"
                brands={[{ id: "omnicore" }]}
            />
            <AreasVertical
                slides={[
                    {
                        id: "erp",
                        title: "ERP Excellence Center",
                        text: (
                            <>
                                <span className="font-inter-bold">
                                    Transformamos negócios entregando exatamente
                                    o que seu ERP precisa:{" "}
                                </span>
                                estratégia, eficiência e suporte que resolve o
                                que ninguém mais resolve. Tudo isso com projetos
                                que elevam a performance, aumentam a
                                produtividade e impulsionam a evolução contínua
                                através do{" "}
                                <span className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] bg-clip-text text-transparent">
                                    centro de excelencia.
                                </span>
                            </>
                        ),
                    },
                    {
                        id: "consulting",
                        title: "Consulting",
                        text: (
                            <>
                                A{" "}
                                <span className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] bg-clip-text text-transparent">
                                    "OmniFactory"
                                </span>{" "}
                                é a fábrica inteligente de desenvolvimento da
                                Omnicore. Unimos tecnologia, especialização e
                                agilidade para entregar soluções personalizadas
                                e sustentáveis em ERPs líderes do mercado: SAP,
                                TOTVS e Senior.
                            </>
                        ),
                    },
                ]}
                bgColor="bg-gradient-to-r from-[#4B3BDB] to-[#A002CB]"
            />
            <MarcaVertical
                logoSrc="../assets/omnicore_logo.svg"
                backgroundImage="../assets/omnicore_background.png"
                buttonBgGradient="bg-gradient-to-r from-[#4B3BDB] to-[#A002CB]"
                infoText={
                    <>
                        <span className="font-inter-bold">
                            Consultoria estratégica em soluções SAP, TOTVS e
                            SENIOR.
                        </span>{" "}
                        Padrão premium de suporte: menor burocracia, maior
                        agilidade e foco total no sucesso do cliente.
                    </>
                }
            />
            <LinksVertical
                areasData={[
                    {
                        icon: "../assets/servicos/erp_icon.svg",
                        iconHover: "../assets/servicos/erp_icon.svg",
                        title: "ERP Excellence Center",
                        text: (
                            <>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/erp-expertise"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        ERP Expertise
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/advisor"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Advisor
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/ams"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        AMS
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/erp-smartsourcing"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        SmartSourcing
                                    </a>
                                </div>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "/erp",
                    },
                    {
                        icon: "../assets/servicos/consulting_icon.svg",
                        iconHover: "../assets/servicos/consulting_icon.svg",
                        title: "Consulting",
                        text: (
                            <>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/omnifactory"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        OmniFactory
                                    </a>
                                </div>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "/omnifactory",
                    },
                ]}
            />
            <Video />
            <Marcas />
            <Clientes />
            <Depoimentos />
            <Rodape />
        </>
    );
}

export default Solutions;
